angular.module('CarsSaraBo').factory('OpaqueRateGAConfig', ['GAService', function (gaService) {
	return {
		reviewGa: function () {
			const EVENT_CATEGORY = "Autos_tarifa_opaca";
			const PAGE_VIEW = "Page view";
			const ADD_OPAQUE_RATE = "Agregar tarifa opaca";
			const HELPBOX_BUTTON = "Formulario";
			const SEE_DETAIL = "Ver detalle";
			const HIDE_DETAIL = "Ocultar detalle";
			const CANCEL = "Cancelar";

			var mapInfo = {
				"Page_view": function (eventName) {
					gaService.notify(EVENT_CATEGORY, eventName, [PAGE_VIEW])
				},
				"Agregar_tarifa_opaca": function (eventName) {
					gaService.notify(EVENT_CATEGORY, eventName, [ADD_OPAQUE_RATE])
				},
				"Boton_consulta": function (eventName) {
					gaService.notify(EVENT_CATEGORY, eventName, [HELPBOX_BUTTON])
				},
				"Eliminar_tarifa_opaca": function (eventName, param) {
                    gaService.notify(EVENT_CATEGORY, eventName, [param])
                },
				"Modal_ayuda": function (eventName, param) {
					gaService.notify(EVENT_CATEGORY, eventName, [param])
				},
                "Ver_detalle": function (eventName) {
                    gaService.notify(EVENT_CATEGORY, eventName, [SEE_DETAIL])
                },
                "Ocultar_detalle": function (eventName) {
                    gaService.notify(EVENT_CATEGORY, eventName, [HIDE_DETAIL])
                },
				"Guardar_tarifa_opaca": function (eventName, discount) {
					gaService.notify(EVENT_CATEGORY, eventName, [discount])
				},
				"Cancelar": function (eventName) {
					gaService.notify(EVENT_CATEGORY, eventName, [CANCEL])
				},
				"Errores_de_validacion": function (eventName, field, message) {
					gaService.notify(EVENT_CATEGORY, eventName, [field, message])
				},
                "Modal_ayuda_desde_crear_tarifa": function (eventName, param) {
                    gaService.notify(EVENT_CATEGORY, eventName, [param]);
                }
			}
			return {
				send: function (eventName, param1, param2) {
					mapInfo[eventName].call(mapInfo, eventName, param1, param2);
				}
			}
		}
	}
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/opaque-rate/opaque-rate-ga-config.component.js
// module id = 830
// module chunks = 3